import React from "react";
import { successLogo } from "../../../../assets/images";
import { formatAmount } from "../../../../utils/formatTime";
import SurveyCard from "../../../../components/survey/SurveyCard";

const DataSuccess = ({
  amount,
  phone,
  planName,
  setOpenData,
  setOpenDataSuccess,
}: any) => {
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        {/* <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
                setOpenSwapSuccess(true);
              setOpenSwapPreview(true);
            }}
            className="flex items-center gap-2 "
          >
            <SlArrowLeft className="dark:text-[#D8D8D8] text-gray-800 text-[12px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Preview Swap
          </h4>
        </div> */}
        <div className="w-full flex justify-center px-3 md:px-6 items-center flex-col gap-4">
          <div className="w-[116px] h-[116px]">
            <img src={successLogo} className="w-full h-full bg-cover" alt="" />
          </div>
          <h4 className="font-sora font-bold text-gray-900 dark:text-gray-100 text-[24px]">
            Transaction complete
          </h4>
          <h4 className=" font-medium text-gray-500 dark:text-gray-400 text-center text-[15px]">
            You bought {planName}
            {amount ? ` worth NGN${formatAmount(amount)}` : ""} Data to {phone}
          </h4>
        </div>
        {/* Renders only when the admin gave the survey the TRANSACTION_SUCCESS
            placement; nothing shows otherwise. */}
        <SurveyCard placement="TRANSACTION_SUCCESS" className="mt-8" />
        <button
          onClick={() => {
            setOpenDataSuccess(false);
          }}
          className="mt-16 border-secondary_button border flex justify-center items-center text-secondary_button text-[15px] font-medium h-[48px] w-full rounded-xl"
        >
          Done
        </button>
        <button
          onClick={() => {
            setOpenDataSuccess(false);
            setOpenData(true);
          }}
          className="mt-6 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl"
        >
          Make another transacation
        </button>
      </div>
    </div>
  );
};

export default DataSuccess;
